import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var AlertHexagon = function AlertHexagon(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 8v4.0001m0 4h.01M3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5755.2672.133.0274.27.0274.403 0 .1501-.0309.2919-.1096.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5726 21 16.4013 21 16.0586v-8.117c0-.3427 0-.514-.0505-.6668a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.403 0c-.1501.031-.2919.1097-.5755.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415"
    })
  }));
};
export default AlertHexagon;